/**
 * Motor do Quiz Abhaya — Recomendação de Protocolos de Skincare
 *
 * Gerencia estado (q1, q2, q3), navegação entre steps,
 * busca de combinação no JSON e persistência via localStorage.
 */

(function () {
  'use strict';

  const STORAGE_KEY = 'abhaya_quiz_state';
  const STEPS = ['intro', 1, 2, 3, 'result'];

  /** @type {{ currentStep: string|number, q1: string|null, q2: string|null, q3: string|null }} */
  let state = {
    currentStep: 'intro',
    q1: null,
    q2: null,
    q3: null,
  };

  const data = window.AbhayaQuizData;
  if (!data) return;

  /* ---- Elementos ---- */
  const quizEl = document.querySelector('.abhaya-quiz');
  if (!quizEl) return;

  const introEl = quizEl.querySelector('[data-step="intro"]');
  const stepEls = [
    null,
    quizEl.querySelector('[data-step="1"]'),
    quizEl.querySelector('[data-step="2"]'),
    quizEl.querySelector('[data-step="3"]'),
  ];
  const resultEl = quizEl.querySelector('[data-step="result"]');

  /* ---- localStorage ---- */
  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (_) {
      /* silencioso */
    }
  }

  function loadState() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed && typeof parsed.currentStep !== 'undefined') {
          state = parsed;
          return true;
        }
      }
    } catch (_) {
      /* silencioso */
    }
    return false;
  }

  function clearState() {
    state = { currentStep: 'intro', q1: null, q2: null, q3: null };
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (_) {
      /* silencioso */
    }
  }

  /* ---- Renderizar opções ---- */
  function renderOptions() {
    const meta = data._meta;
    const questionMap = {
      q1: meta.q1_opcoes,
      q2: meta.q2_opcoes,
      q3: meta.q3_opcoes,
    };

    Object.entries(questionMap).forEach(function ([questionKey, options]) {
      const container = quizEl.querySelector('[data-question="' + questionKey + '"]');
      if (!container || container.children.length > 0) return;

      Object.entries(options).forEach(function ([value, label]) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'abhaya-quiz__option-btn';
        btn.setAttribute('data-value', value);
        btn.textContent = label;
        container.appendChild(btn);
      });
    });
  }

  /* ---- Navegação ---- */
  function showStep(step) {
    /* Esconder tudo */
    if (introEl) introEl.style.display = 'none';
    stepEls.forEach(function (el) {
      if (el) el.style.display = 'none';
    });
    if (resultEl) resultEl.style.display = 'none';

    /* Mostrar step atual */
    if (step === 'intro') {
      introEl.style.display = '';
      updateProgress(0);
    } else if (step === 'result') {
      resultEl.style.display = '';
      renderResult();
      updateProgress(3);
    } else {
      var stepNum = parseInt(step, 10);
      if (stepEls[stepNum]) {
        stepEls[stepNum].style.display = '';
        highlightSelected(stepNum);
      }
      updateProgress(stepNum);
    }

    state.currentStep = step;
    saveState();

    /* Scroll suave para o topo do quiz */
    quizEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function highlightSelected(stepNum) {
    var questionKey = 'q' + stepNum;
    var selectedValue = state[questionKey];
    var container = quizEl.querySelector('[data-question="' + questionKey + '"]');
    if (!container) return;

    Array.from(container.children).forEach(function (btn) {
      btn.classList.toggle(
        'abhaya-quiz__option-btn--selected',
        btn.getAttribute('data-value') === selectedValue
      );
    });
  }

  /* ---- Progresso ---- */
  function updateProgress(stepNum) {
    var progressEl = quizEl.querySelector('[data-progress]');
    if (!progressEl) return;

    /* Steps */
    for (var i = 1; i <= 3; i++) {
      var progressStep = progressEl.querySelector('[data-progress-step="' + i + '"]');
      if (!progressStep) continue;
      progressStep.classList.remove('abhaya-quiz__progress-step--active', 'abhaya-quiz__progress-step--done');
      if (i === stepNum) {
        progressStep.classList.add('abhaya-quiz__progress-step--active');
      } else if (i < stepNum) {
        progressStep.classList.add('abhaya-quiz__progress-step--done');
      }
    }

    /* Dividers */
    var dividers = progressEl.querySelectorAll('.abhaya-quiz__progress-divider');
    dividers.forEach(function (div, idx) {
      div.classList.toggle('abhaya-quiz__progress-divider--done', idx < stepNum - 1);
    });

    /* Fill bar */
    var fill = progressEl.querySelector('[data-progress-fill]');
    if (fill) {
      var percent = stepNum === 0 ? 0 : Math.round((stepNum / 3) * 100);
      fill.style.width = percent + '%';
    }

    /* Visibility */
    progressEl.style.display = stepNum === 0 ? 'none' : '';
  }

  /* ---- Resultado ---- */
  function findCombination() {
    if (!data.combinacoes || !state.q1 || !state.q2 || !state.q3) return null;
    return data.combinacoes.find(function (c) {
      return c.q1 === state.q1 && c.q2 === state.q2 && c.q3 === state.q3;
    }) || null;
  }

  function formatProductUrl(handleOrPath) {
    if (!handleOrPath) return '#';
    var path = String(handleOrPath).trim();
    if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0) {
      return path;
    }
    // Remove /products/ ou barras iniciais para obter o ID/handle puro
    var clean = path.replace(/^\/products\//, '').replace(/^\/+/, '');
    
    // Se existir mapeamento dinâmico no Shopify (ID de produto ou variante -> handle), usa o handle correspondente
    if (window.AbhayaProductMap && window.AbhayaProductMap[clean]) {
      clean = window.AbhayaProductMap[clean];
    }
    
    return '/products/' + encodeURIComponent(clean);
  }

  function renderResult() {
    var combo = findCombination();
    if (!combo) return;

    /* Summary tags */
    var summaryEl = quizEl.querySelector('[data-result-summary]');
    if (summaryEl) {
      summaryEl.innerHTML =
        '<span class="abhaya-quiz__summary-tag">' + escapeHtml(combo.q1_label) + '</span>' +
        '<span class="abhaya-quiz__summary-tag">' + escapeHtml(combo.q2_label) + '</span>' +
        '<span class="abhaya-quiz__summary-tag">' + escapeHtml(combo.q3_label) + '</span>';
    }

    /* Produto Único */
    var unicoEl = quizEl.querySelector('[data-result-unico]');
    if (unicoEl) {
      var unicoHandle = combo.shopify_handles ? combo.shopify_handles.produto_unico : null;
      var unicoUrl = formatProductUrl(unicoHandle);
      unicoEl.innerHTML =
        '<a href="' + unicoUrl + '" class="abhaya-quiz__product-link">' +
          '<div class="abhaya-quiz__product-icon">✦</div>' +
          '<h3 class="abhaya-quiz__product-name">' + escapeHtml(combo.produto_unico) + '</h3>' +
          '<span class="abhaya-quiz__product-cta">Ver produto →</span>' +
        '</a>';
    }

    /* Protocolo Completo */
    var protocoloEl = quizEl.querySelector('[data-result-protocolo]');
    if (protocoloEl) {
      var names = combo.protocolo_completo || [];
      var handles = (combo.shopify_handles && combo.shopify_handles.protocolo_completo) || [];
      var html = '';
      for (var i = 0; i < names.length; i++) {
        var itemUrl = formatProductUrl(handles[i]);
        html +=
          '<a href="' + itemUrl + '" class="abhaya-quiz__protocol-item">' +
            '<span class="abhaya-quiz__protocol-number">' + (i + 1) + '</span>' +
            '<span class="abhaya-quiz__protocol-name">' + escapeHtml(names[i]) + '</span>' +
            '<span class="abhaya-quiz__protocol-arrow">→</span>' +
          '</a>';
      }
      protocoloEl.innerHTML = html;
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ---- Tabs ---- */
  function initTabs() {
    var tabs = quizEl.querySelectorAll('[data-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');

        /* Ativar tab */
        tabs.forEach(function (t) {
          t.classList.toggle('abhaya-quiz__tab--active', t === tab);
        });

        /* Ativar conteúdo */
        var contents = quizEl.querySelectorAll('[data-tab-content]');
        contents.forEach(function (c) {
          var isTarget = c.getAttribute('data-tab-content') === target;
          c.classList.toggle('abhaya-quiz__tab-content--active', isTarget);
        });
      });
    });
  }

  /* ---- Event Listeners ---- */
  function bindEvents() {
    /* Botão Começar */
    var startBtn = quizEl.querySelector('[data-start]');
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        showStep(1);
      });
    }

    /* Opções */
    quizEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.abhaya-quiz__option-btn');
      if (!btn) return;

      var container = btn.closest('[data-question]');
      if (!container) return;

      var questionKey = container.getAttribute('data-question');
      var value = btn.getAttribute('data-value');

      /* Salvar resposta */
      state[questionKey] = value;

      /* Highlight */
      Array.from(container.children).forEach(function (b) {
        b.classList.toggle('abhaya-quiz__option-btn--selected', b === btn);
      });

      /* Avançar após breve delay (feedback visual) */
      setTimeout(function () {
        var stepNum = parseInt(questionKey.replace('q', ''), 10);
        if (stepNum < 3) {
          showStep(stepNum + 1);
        } else {
          showStep('result');
        }
      }, 250);
    });

    /* Botões Voltar */
    quizEl.addEventListener('click', function (e) {
      var backBtn = e.target.closest('[data-back]');
      if (!backBtn) return;

      var stepEl = backBtn.closest('[data-step]');
      if (!stepEl) return;

      var currentStepNum = parseInt(stepEl.getAttribute('data-step'), 10);
      if (currentStepNum > 1) {
        showStep(currentStepNum - 1);
      } else {
        showStep('intro');
      }
    });

    /* Botão Refazer */
    var restartBtn = quizEl.querySelector('[data-restart]');
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        clearState();
        /* Limpar seleções */
        quizEl.querySelectorAll('.abhaya-quiz__option-btn--selected').forEach(function (b) {
          b.classList.remove('abhaya-quiz__option-btn--selected');
        });
        showStep('intro');
      });
    }

    initTabs();
  }

  /* ---- Inicialização ---- */
  function init() {
    renderOptions();
    bindEvents();

    var restored = loadState();
    if (restored && state.currentStep !== 'intro') {
      showStep(state.currentStep);
    } else {
      showStep('intro');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
